<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="receipt icon"></i>
      {{ $t("fel bill") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/fel_gt.jpg" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui grid">
          <div class="twelve wide column">
            <h2 class="ui small header">
              <i class="exchange icon"></i>
              <div class="content">
                {{ $t("id") }} {{ transaction.uuid }}
                <div class="sub header">
                  {{
                    transaction.create_date
                      | formatDate(enterprise_setup.detailed_date_format)
                  }}
                </div>
              </div>
            </h2>
          </div>
          <div class="four wide column">
            <h2
              class="ui right floated small header"
              v-bind:class="{
                green: transaction.status_code == 'E',
                red: transaction.status_code == 'F',
              }"
            >
              <i
                class="icon"
                v-bind:class="{
                  'green check': transaction.status_code == 'E',
                  'red remove': transaction.status_code == 'F',
                }"
              ></i>
              <div class="content">
                {{ transaction.status_code | translate_status(this) }}
              </div>
            </h2>
          </div>
        </div>
        <div class="ui three item top attached tabular menu" ref="tabs">
          <a class="active item" data-tab="billing">{{ $t("billing") }}</a>
          <a class="item" data-tab="request">{{ $t("request") }}</a>
          <a class="item" data-tab="response">{{ $t("response") }}</a>
          <!-- <a
          class="item"
          data-tab="void"
          v-show="
            transaction && transaction.vis_voids && transaction.vis_voids.length
          "
          >{{ $t("void") }}</a
        > -->
        </div>
        <billing
          class="ui bottom attached active tab segment"
          data-tab="billing"
          :transaction="transaction"
        >
        </billing>
        <request
          class="ui bottom attached tab segment"
          data-tab="request"
          :transaction="transaction"
        >
        </request>
        <response
          class="ui bottom attached tab segment"
          data-tab="response"
          :transaction="transaction"
        >
        </response>
        <!-- <voided
        class="ui bottom attached tab segment"
        data-tab="void"
        :transaction="transaction"
        v-show="
          transaction && transaction.vis_voids && transaction.vis_voids.length
        "
      >
        <pre> {{ transaction.vis_voids }} </pre>
      </voided> -->
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import { local_api, stringify, enterprise_setup } from "@/utils";
import filters from "@/filters";
import { translate_status, translate_type } from "../local_translator";
import { success_toast } from "../../../utils";
import Request from "./Request.vue";
import Response from "./Response.vue";
import Billing from "./Billing.vue";
// import Voided from "./Void.vue";

filters.translate_status = translate_status;
filters.translate_type = translate_type;

export default {
  name: "FelGTTransactionModal",
  filters: filters,
  components: {
    Request,
    Response,
    Billing,
    // Voided,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      transaction: { request_data: "", response_data: {} },
      footer_buttons: [],
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        vm.updateTransaction(data.uuid);
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            window.jQuery(vm.$refs.tabs).find(".item").tab();
          },
          onHide() {
            vm.form.form("reset");
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          nit: ["empty"],
          name: ["empty"],
        },
      });
    },
    updateTransaction(transaction_uuid) {
      let vm = this;
      local_api(this, "post", "/fel_guatemala/billing/do-get", {
        u: transaction_uuid,
      })
        .then((tx) => {
          vm.transaction = tx;
          if (tx) {
            tx.setup = JSON.parse(tx.setup);
            tx.response_data = JSON.parse(tx.response_data);
            vm.footer_buttons.push({
              text: vm.$t("void"),
              color: "orange",
              icon: "stamp",
              click: vm.void,
              visibility_condition:
                vm.transaction && vm.transaction.status_code == "E"
                  ? true
                  : false,
            });
          }
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    void() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to void transaction?"),
        function () {
          local_api(vm, "post", "/fel_guatemala/billing/do-void", {
            u: vm.transaction.uuid,
          })
            .then(() => {
              vm.footer_buttons = [];
              success_toast(vm.$t("void succeeded"));
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        },
      );
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
